const env = window.envData;

export const default_locales = env.REACT_APP_LOCALES ?? ['en', 'de', 'fr']
export const default_locale_language = env.REACT_APP_DEFAULT_LOCALE ?? 'de'
export const show_sensor_data = env.REACT_APP_SHOW_SENSOR_DATA ?? true
export const show_fanshop = env.REACT_APP_SHOW_FANSHOP ?? true
export const default_locations = env.REACT_APP_LOCATIONS ?? []
export const backend_api_url = env.REACT_APP_BACKEND_API_URL ?? ""

delete window.envData;